import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

export const RowContainer = styled(Row)`
  min-height: 60px;
  padding-top: 15px;
  padding-bottom: 14px;
`;

export const LabelSection = styled(Row)`
  width: 148px;
  justify-content: flex-end;
`;

export const ContentSection = styled(Row)`
  flex: 1;
`;
